module.exports = __webpack_public_path__ + "src/img/artist/artistpage1_2.svg?ff777e8a215288ae94f7d53ac7e14946";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/artistpage1_2.svg
// module id = 119
// module chunks = 0